import * as WebViewBridge from '@/checkout-instore-legacy/utils/WebViewBridge'
import { isMobileNativePlatform } from '@/checkout-instore-legacy/device/utils'

export function shareLink(link: string) {
  if (isMobileNativePlatform()) {
    WebViewBridge.sendEvent({
      type: 'vtex-pinpad',
      data: {
        mobileLinkingUrl: link,
      },
    })
    return
  }

  window.open(link)
}
